// Phase 0: Minimal result pattern for transcript domain operations.
// Avoids throwing for expected failures and centralizes warnings.
export type TranscriptSuccess<T> = { ok: true; value: T; warnings?: string[] };
export type TranscriptFailure = {
  ok: false;
  error: string; // lightweight now; can evolve to structured ServiceError later
  diagnostics?: Record<string, unknown>;
};
export type TranscriptResult<T> = TranscriptSuccess<T> | TranscriptFailure;

export function ok<T>(value: T, warnings?: string[]): TranscriptSuccess<T> {
  return { ok: true, value, warnings };
}

export function fail(
  error: string,
  diagnostics?: Record<string, unknown>,
): TranscriptFailure {
  return { ok: false, error, diagnostics };
}
